module.exports = __webpack_public_path__ + "img/sup_register_4.2a215ff9.png";